import {
  FETCH_REVENUE_REQUEST,
  FETCH_REVENUE_SUCCESS,
  FETCH_REVENUE_FAILURE,
} from '../constants/revenueConstants';

const initialState = {
  data: [],
  loading: false,
  error: null,
  revenue: null,
  pagination: {
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
  },
};

const revenueReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REVENUE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REVENUE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.response || [],
        revenue: action.payload.revenue || null,
        pagination: action.payload.pagination || state.pagination,
      };
    case FETCH_REVENUE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default revenueReducer;